import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth, isRestricted } from "@/context/AuthContext";

export const NONE = "__none";

export const SimpleSelect = ({ value, onChange, options, placeholder, testId, allowNone: allowNoneProp, noneLabel = "None", scoped }) => {
  const { user } = useAuth() || {};
  // members limited to specific entities must always pick one of them
  const allowNone = allowNoneProp && !(scoped && isRestricted(user));
  return (
  <Select value={value || (allowNone ? NONE : undefined)} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
    <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder || "Select entity"} /></SelectTrigger>
    <SelectContent>
      {allowNone && <SelectItem value={NONE}>{noneLabel}</SelectItem>}
      {options.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`${testId}-opt-${String(o.value).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
  );
};

export const entityOptions = (ents) => (ents || []).map((e) => ({ value: e.id, label: e.name }));
export const listOptions = (arr) => (arr || []).map((x) => ({ value: x, label: x }));
